import { bootProfileContainer } from '@/modules/users/Profile/ProfileServiceProvider';
import FileUploadFieldWrapper from '@/modules/fields/components/FileUploadWrapper';
import { mount as mountDarkmode } from '@/common/darkmode.js';
import { mountVueComponent, mountVueWithComponents } from '@/lib/mount-vue-component';

export default function () {
	bootProfileContainer();
	mountDarkmode();

	import('@/lib/components/Fields/validator/Validator.vue').then((validator) => {
		mountVueWithComponents('validator', validator, { FileUploadFieldWrapper });
	});

	import('@/modules/users/components/UserFields.vue').then((userFields) => {
		mountVueComponent('user-fields', userFields);
	});

	import('@/modules/users/Profile/Profile.vue').then((profile) => {
		mountVueComponent('profile', profile);
	});
}
